<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" title="Guardar" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Instalación</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedEntidad = !isCollapsedEntidad"
                       [attr.aria-expanded]="!isCollapsedEntidad" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Principales
                            <i *ngIf="isCollapsedEntidad" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedEntidad" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpIdentificador">Identificador</label>
                                <input formControlName="Identificador" name="Identificador" title=""
                                       class="form-control" id="inpIdentificador" type="text" value="" [ngClass]="displayFieldCss('Identificador')" maxlength="50">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Identificador','required')">
                                    Identificador es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpApellidos">Operador</label>
                                <input formControlName="Operador" name="Operador" title=""
                                       class="form-control" id="inpOperador" type="text" value="" [ngClass]="displayFieldCss('Operador')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Operador','required')">
                                    Apellidos es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNumRegistro">Num. Registro</label>
                                <input formControlName="NumRegistro" name="NumRegistro" title=""
                                       class="form-control" id="inpNumRegistro" type="text" value="" [ngClass]="displayFieldCss('NumRegistro')" maxlength="9">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('NumRegistro','required')">
                                    Num. Registro es obligatorio
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="intTipoInstalacion">Tipo Instalación</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listTipoInstalacion"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdTipoInstalacion"
                                           [readonly]="!listTipoInstalacion || listTipoInstalacion.length === 0"
                                           [loading]="!listTipoInstalacion || listTipoInstalacion.length === 0"
                                           notFoundText="Tipo Instalación no encontrada"
                                           [ngClass]="displayFieldCssNgSelect('IdTipoInstalacion')"
                                           placeholder="-- Seleccione Tipo Instalación --"
                                           clearAllText="Eliminar selección">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoInstalacion','required')">
                                    Tipo Instalación es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="intProvincia">Provincia</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listProvincia"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdProvincia"
                                           [readonly]="!listProvincia || listProvincia.length === 0"
                                           [loading]="!listProvincia || listProvincia.length === 0"
                                           notFoundText="Provincia no encontrada"
                                           [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                           placeholder="-- Seleccione una Provincia --"
                                           clearAllText="Eliminar selección">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                    Provincia es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpDireccion">Dirección</label>
                                <input formControlName="Direccion" name="Direccion" title=""
                                       class="form-control" id="inpDireccion" type="text" value="" [ngClass]="displayFieldCss('Direccion')" maxlength="180">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Direccion','required')">
                                    Dirección es obligatorio
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpLocalidad">Localidad</label>
                                <input formControlName="Localidad" name="Localidad" title=""
                                       class="form-control" id="inpLocalidad" type="text" value="" [ngClass]="displayFieldCss('Localidad')" maxlength="100">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Localidad','required')">
                                    Localidad es obligatoria
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpCodigoPostal">Código Postal</label>
                                <input formControlName="CodigoPostal" name="CodigoPostal" title="" numbersOnly
                                       class="form-control" id="inpCodigoPostal" type="text" value="" [ngClass]="displayFieldCss('CodigoPostal')" maxlength="5">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostal','required')">
                                    Código Postal es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpTelefono">Telefono</label>
                                <input formControlName="Telefono" name="Telefono" title=""
                                       class="form-control" id="inpTelefono" type="text" value="" [ngClass]="displayFieldCss('Telefono')" maxlength="80">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Telefono','required')">
                                    Teléfono es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpEmail">Email</label>
                                <input formControlName="Email" name="Email" title=""
                                       class="form-control" id="inpEmail" type="text" [ngClass]="displayFieldCss('Email')" value="" maxlength="50">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','required')">
                                    Email Persona Contacto es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','email')">
                                    Formato incorrecto
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpObservaciones">Observaciones</label>
                                <textarea style="resize:none" formControlName="Observaciones" name="Observaciones" title=""
                                          class="form-control" id="inpObservaciones" type="text" value="" maxlength="5000"></textarea>
                            </div>
                        </div>

                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpTecnicoResponsable">Técnico Responsable</label>
                                <input formControlName="TecnicoResponsable" name="Telefono" title=""
                                       class="form-control" id="inpTecnicoResponsable" type="text" value="" [ngClass]="displayFieldCss('TecnicoResponsable')" maxlength="80">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('TecnicoResponsable','required')">
                                    Técnico Responsable es obligatorio
                                </div>
                            </div>

                            <!--<p-toggleButton class="form-control-togglebutton" formControlName="Baja" onLabel="Sí" offLabel="NO" (onChange)="onSelectActivo()"
                                            onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>-->

                            <!--<div class="form-group col-md-3">
        <label class="col-form-label" for="inpFechaAlta">Fecha Alta</label>
        <p-calendar formControlName="FechaAlta" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaAlta')"
                    [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
    </div>

    <div class="form-group col-md-3">
        <label class="col-form-label" for="inpFecha">Fecha Baja</label>
        <p-calendar formControlName="FechaBaja" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaBaja')"
                    [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
    </div>-->

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

